export { default } from './FormGroup';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/FormGroup/index.js
// module id = 179
// module chunks = 0